<template>
  <div :class="['chatBubble','text-left',show?'show':'']" >
        <ChatIcon @click.native="showChatBox()" :class="[show?'noClick':'']"/>
        <div class="card">
            <form @submit.prevent="inputSubmit()">
              <b-input-group class="px-2 py-2">
                  <b-form-input
                      @keypress="preventLength"
                      @change="preventLength"
                      @keyup="preventLength"
                      @keydown="preventLength"
                      maxlength="25"
                      ref="chatInput"
                      spellcheck="false"
                      autocomplete="off"                      
                      @blur="hideChatBox(true)"
                      v-model="inputText"
                      trim
                  ></b-form-input>
                  <b-input-group-append>
                      <b-button type="submit" variant="info" size="sm"><unicon name="message"/></b-button>
                  </b-input-group-append>
              </b-input-group>
            </form>
            <div class="quickChats px-2 pb-2">
                  <b-badge @click="sendMessage(text)" v-for="(text,index) in quickChat" :key="index" class="mr-1" variant="info">{{text}}</b-badge>
            </div>
        </div>
  </div>
</template>
<script>
import config from "@/config";
import server from "@/server";
import store from "@/store";
import ChatIcon from "@/components/svg/ChatIcon";

export default {
  data: () => {
    return {
        show:false,
        inputText:'',
        quickChat:config.quickChat
    };
  },
  methods: {
      preventLength(e){
        if (this.inputText.length > 25) {
            this.inputText = this.inputText.substr(0, 25);
        }
      },
      sendMessage(text){
        server.popEmoji(text);
        this.$refs.chatInput.blur();
      },
      inputSubmit(){
        if(!this.inputText.trim().length)return;
        this.sendMessage(this.inputText.trim());
        this.inputText = '';
      },
      hideChatBox(delayed){   
        if(delayed){
          setTimeout(() => {            
            this.show = false;
          }, 250);
        }else{          
            this.show = false;
        }    
      },
      showChatBox(){
        this.show = true;
        setTimeout(() => {
          this.$refs.chatInput.focus();
        }, 200);
      }
  },
  components: {
      ChatIcon
  }
};
</script>
